export default {
  CASH_REGISTERS_LIST: "Liste des caisses",
  ADD_CASH_REGISTER: "Ajouter une caisse",
  CASH_REGISTER_ADDED: "caisse ajoutée",
  EDIT_CASH_REGISTER: "Modifier la caisse",
  CASH_REGISTER_UPDATED: "caisse mise à jour",
  DELETE_THIS_CASH_REGISTER: "Supprimer cette caisse ?",
  CASH_REGISTER_DELETED: "caisse supprimée",
  STARTS_AT: "Début",
  ENDS_AT: "Fin",
  TITLE: "Titre",
  CASH_REGISTER_CATEGORY_PEDAGO: "Pédagogie",
  EVENT_CATEGORY_THEMATIC_MEAL: "Repas Thématique",
  EVENT_CATEGORY_TASTING: "Dégustation",
  EVENT_CATEGORY_PROMOTION: "Promotion",
  EVENT_CATEGORY_EVENT: "Événement",
  EVENT_CATEGORY_INTERNAL_JOURNAL: "Journal Interne",
  EVENT_CATEGORY_CLIENT_JOURNAL: "Journal Client",
  EVENT_CATEGORY_SURVEY: "Sondage",
  EVENT_CATEGORY_MONTHLY_INSPIRATION: "Inspiration du Mois",
  EVENT_CATEGORY_OPEN_HOUSE: "Porte-Ouverte",
  SHOW_MY_EVENTS: "Voir les caisses qui me concernent",
  SHOW_ALL: "Voir tous les caisses",
  AUTO_CREATE_EQUIPMENT: "Créer automatiquement un équipement",
  AUTO_CREATE_EQUIPMENT_HELP: "Si activé, un équipement sera automatiquement créé et lié à cette caisse. Les modifications apportées à l'un seront synchronisées avec l'autre.",
  LINKED_EQUIPMENT: "Équipement lié",
  ISTHERA_PARTIAL_PREFILL: "Remplissage partiel des lectures depuis la caisse",
  ISTHERA_PARTIAL_PREFILL_HELP:
    "À cocher quand le terminal de paiement n'est pas relié à la caisse : seuls le numéro Z, le total du Z et le nombre de transactions sont remplis. Les paiements se saisissent à la main.",
  ISTHERA_PREFILL: "Remplissage des lectures depuis la caisse",
  ISTHERA_PREFILL_FULL: "Complet",
  ISTHERA_PREFILL_PARTIAL: "Partiel : numéro Z, total du Z et transactions",
  ISTHERA_PREFILL_NOT_OPENED: "Pas encore activé pour cette école",
};
